import GaiaLeaf from './GaiaLeaf'

export default GaiaLeaf
